import { Card, Flex, Typography } from "antd";
import React from "react";

import tick from "../../../../assets/icons/tick-circle-white.svg";
import receipt from "../../../../assets/icons/receipt-text.svg";
import health from "../../../../assets/icons/health.svg";

export default function InsuranceStatistics() {
  const stats = [
    { title: "Total Claimed", value: "$50,550", icon: health, iconALt: "health" },
    { title: "Acceptance Rate", value: "82%", icon: receipt, iconALt: "receipt" },
    { title: "Avg. Processing Time", value: "4.2 Days", icon: tick, iconALt: "tick" },
  ];

  return (
    <Flex vertical gap={10} style={{ width: "50%" }}>
      {stats.map((item, idx) => (
        <Card key={idx} size="small" style={{ padding: 5 }}>
          <Flex align="center" justify="space-between">
            <Flex vertical>
              <Typography.Title level={4} style={{ marginBottom: 0 }}>
                {item.title}
              </Typography.Title>
              <Typography.Title level={4} style={{ marginTop: 0, color: "#6b43b5" }}>
                {item.value}
              </Typography.Title>
            </Flex>

            <Flex align="center" justify="center" style={{ width: 73, height: 73, borderRadius: 100, backgroundColor: "#7F59CE" }}>
              <img src={item.icon} alt={item.iconAlt} />
            </Flex>
          </Flex>
        </Card>
      ))}
    </Flex>
  );
}
